// @flow

import { type Merchant } from '@tectonics/prs/merchant/types';

export function getGoogleAnalyticsTrackingIds(merchant: Merchant): ImmutableArray<string> {
  return merchant['google_analytics_tracking_ids'] || [];
}
